export function accountModuleOutput ({userMsg, vipLevelInfo,levelName,funcType,levelTypeTag}) {
    let textArr = [{
        name: '您的账户是'
    },{
        name: levelName,
        highlight: true
    }];
    let tmpArr = [];
    switch (funcType) {
        case 'materialCapacity':
            let capacity = 0;
            if (vipLevelInfo.size > 1024) {
                capacity = Math.round((vipLevelInfo.size / 1024)) + 'G';
            } else {
                capacity = vipLevelInfo.size + 'M';
            }
            tmpArr = [{
                name: '，素材空间的容量上限为'
            }, {
                name: capacity,
                highlight: true
            }];
        break;
        case 'AIDubbing':
            if (levelTypeTag === 'isPoor') {
                tmpArr = [{
                    name: '，暂不支持使用'
                }, {
                    name: 'AI配音',
                    highlight: true
                }];
            } else if (levelTypeTag === 'isSolo' ||
                levelTypeTag === 'isTmpSolo' ||
                levelTypeTag === 'isShop'
            ) {
                tmpArr = [{
                    name: '，AI配音次数共'
                }, {
                    name: userMsg.kdxfTimes,
                    highlight: true
                }, {
                    name: '次已经用完'
                }];
            } else if (!userMsg.kdxfRemain) {
              tmpArr = [{
                name: '，AI配音次数共'
              }, {
                name: userMsg.kdxfTimes,
                highlight: true
              }, {
                name: '次已经用完'
              }];
            }
            break;
        case 'enterpriseSpeaker':
            tmpArr = [{
                name: '，暂不支持使用'
            }, {
                name: '企业专属音色',
                highlight: true
            }];
            break;
        case '720P':
            // if (levelTypeTag === 'isPoor') {
            //     tmpArr = [{
            //         name: '，暂不支持使用'
            //     }, {
            //         name: '720P画质导出',
            //         highlight: true
            //     }];
            // } else
            if (levelTypeTag === 'isPoor' || levelTypeTag === 'isSolo' || levelTypeTag === 'isTmpSolo') {
                tmpArr = [{
                    name: '，720P导出次数共'
                }, {
                    name: vipLevelInfo.videoTransformTime,
                    highlight: true
                }, {
                    name: '次已经用完'
                }];
            }
            break;
        case 'applyWatermark':
          if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isTmpSupremeEnterprise' || levelTypeTag === 'isTmpEnterprise') {
              tmpArr = [{
                  name: '，暂不支持使用'
              }, {
                  name: '无水印/自定义水印',
                  highlight: true
              }];
          } else if (levelTypeTag === 'isSolo' || levelTypeTag === 'isShop') {
              tmpArr = [{
                  name: '，无水印/自定义水印次数共'
              }, {
                  name: vipLevelInfo.nonWatermark,
                  highlight: true
              }, {
                  name: '次已经用完'
              }];
          }
          break;
        case 'removeWatermark':
            if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isTmpSupremeEnterprise' || levelTypeTag === 'isTmpEnterprise') {
                tmpArr = [{
                    name: '，暂不支持使用'
                }, {
                    name: '无水印',
                    highlight: true
                }];
            } else if (levelTypeTag === 'isSolo') {
                tmpArr = [{
                    name: '，无水印次数共'
                }, {
                    name: vipLevelInfo.nonWatermark,
                    highlight: true
                }, {
                    name: '次已经用完'
                }];
            }
            break;
        case 'selfDefineWatermark':
            if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo'  || levelTypeTag === 'isTmpSupremeEnterprise' || levelTypeTag === 'isTmpEnterprise') {
                tmpArr = [{
                    name: '，暂不支持使用'
                }, {
                    name: '自定义水印',
                    highlight: true
                }];
            }
            break;
        case 'AIDrawing':
          // levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo'
            if (levelTypeTag === 'isPoor') {
                tmpArr = [{
                    name: '，暂不支持使用'
                }, {
                    name: 'AI绘图',
                    highlight: true
                }];
            }
            break;
        case '1080P':
            if (levelTypeTag === 'isGloryEnterprise') {
              tmpArr = [{
                name: '，1080P导出次数共'
              }, {
                  name: '20',
                  highlight: true
              }, {
                name: '次已用完'
              }];
            }
            else if (levelTypeTag !== 'isUpGloryEnterprise' && levelTypeTag !== 'isTmpSupremeEnterprise') {
                tmpArr = [{
                    name: '，暂不支持使用'
                }, {
                    name: '1080P导出',
                    highlight: true
                }];
            }
            break;
        case 'draftNumber':
            tmpArr = [{
                name: `，最多只能保留`
            }, {
                name: vipLevelInfo.draftNumber,
                highlight: true
            },{
                name: `个动画草稿。请`
            },{
                name: '删除已有草稿',
                highlight: false,
                link: true,
                url: '/workplace/dashboard/animation/project'
            }, {
                name: '或将已完成草稿导出为作品'
            }];
            break;
        case 'worksNumber':
            tmpArr = [{
                name: `，最多只能保留`
            }, {
                name: vipLevelInfo.videoNumber,
                highlight: true
            },{
                name: `个动画作品。请`
            },{
                name: '删除已有作品',
                highlight: false,
                link: true,
                url: '/workplace/dashboard/animation/works'
            }, {
                name: '后继续导出'
            }];
            break;
        case 'videoDuration':
           const text = countDuration(vipLevelInfo);
            tmpArr = [{
                name: '，最长仅可制作'
            }, {
                name: text,
                highlight: true
            }, {
                name: '的动画视频，请调节场景页时间后再导出'
            }];
            break;
        case 'pptImport':
            if (levelTypeTag === 'isPoor') {
                tmpArr = [{
                    name: '，暂不支持'
                }, {
                    name: `导入超过${vipLevelInfo.pptSize}M的PPT`,
                    highlight: true
                }];
            } else if (levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo') {
                tmpArr = [{
                    name: '，暂不支持'
                }, {
                    name: `导入超过${vipLevelInfo.pptSize}M的PPT`,
                    highlight: true
                }];
            }
            break;
        case 'AIMatting':
            if (levelTypeTag === 'isPoor') {
                tmpArr = [{
                    name: '，一键抠图'
                },{
                    name: `每天${vipLevelInfo.cutoutTimes}张`,
                    highlight: true
                }, {
                    name: '次数已经用完，请明天再试'
                }];
            } else if (levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo') {
                tmpArr = [{
                    name: '，'
                },{
                    name: `${vipLevelInfo.cutoutTimes}张/天`,
                    highlight: true
                }, {
                    name: '已经用完，请明天再试'
                }];
            } else  {
                // 企业体验版 企业版都是跳转抠图包
                tmpArr = [ {
                    name: '，当前抠图次数已经用完'
                }];
            }
            break;
        case 'selfDefineCover':
            tmpArr = [{
                name: '，暂不支持使用'
            }, {
                name: '自定义视频封面',
                highlight: true
            }];
            break;
        case '480P':
            tmpArr = [{
                name: '，480P导出共'
            }, {
                name: vipLevelInfo.videoTransformTime,
                highlight: true
            },{
                name: '次已经用完'
            }];
            break;
    }
    // console.log('tmpArr', tmpArr);
    textArr = textArr.concat(tmpArr);
    return textArr;
}

export function showCards ({funcType,levelTypeTag, userMsg}) {
    let cards = {};
    switch (funcType) {
        case 'materialCapacity':
            if (levelTypeTag === 'isPoor') {
                cards = {
                    right: false,
                    vip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            } else if (levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo') {
                cards = {
                    right: false,
                    vip: false,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            }
        break;
        case 'AIDubbing':
            if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo') {
                cards = {
                    right: false,
                    vip: true,
                    shopVip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: true,
                    matting: false
                };
            } else if (levelTypeTag === 'isSolo') {
                cards = {
                    right: true,
                    vip: false,
                    shopVip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: true,
                    matting: false
                };
            } else if (levelTypeTag === 'isShop') {
              cards = {
                  right: false,
                  vip: false,
                  shopVip: false,
                  enterpriseVip: true,
                  upEnterpriseVip: true,
                  matting: false
              };
            } else if (!userMsg.kdxfRemain && levelTypeTag === 'isGloryEnterprise') {
              cards = {
                right: false,
                vip: false,
                shopVip: false,
                enterpriseVip: false,
                upEnterpriseVip: true,
                matting: false
              };
            }
            break;
        case 'enterpriseSpeaker':
            cards = {
                right: false,
                vip: false,
                shopVip: false,
                enterpriseVip: true,
                upEnterpriseVip: true,
                matting: false
            };
            break;
        case '720P':
            if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo') {
                cards = {
                    right: false,
                    vip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            } else if (levelTypeTag === 'isSolo') {
                cards = {
                    right: true,
                    vip: false,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            }
            break;
        case 'applyWatermark':
          if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isTmpSupremeEnterprise' || levelTypeTag === 'isTmpEnterprise') {
            cards = {
              right: false,
              vip: true,
              shopVip: true,
              enterpriseVip: true,
              upEnterpriseVip: false,
              matting: false
            };
          } else if (levelTypeTag === 'isSolo') {
            cards = {
              right: true,
              vip: false,
              shopVip: true,
              enterpriseVip: true,
              upEnterpriseVip: false,
              matting: false
            };
          } else if (levelTypeTag === 'isShop') {
            cards = {
              right: false,
              vip: false,
              shopVip: false,
              enterpriseVip: true,
              upEnterpriseVip: false,
              matting: false
            };
          }
          break;
        case 'removeWatermark':
            if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isTmpSupremeEnterprise' || levelTypeTag === 'isTmpEnterprise') {
                cards = {
                    right: false,
                    vip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            } else if (levelTypeTag === 'isSolo') {
                cards = {
                    right: true,
                    vip: false,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            }
            break;
        case 'selfDefineWatermark':
            if (levelTypeTag === 'isPoor' || levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo' || levelTypeTag === 'isTmpSupremeEnterprise' || levelTypeTag === 'isTmpEnterprise') {
                cards = {
                    right: false,
                    vip: false,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            }
            break;
        case 'AIDrawing':
            if (levelTypeTag === 'isPoor') {
                cards = {
                    right: false,
                    vip: true,
                    enterpriseVip: false,
                    upEnterpriseVip: false,
                    matting: false
                };
            }
            break;
        case '1080P':
            if (levelTypeTag !== 'isUpGloryEnterprise' && levelTypeTag !== 'isTmpSupremeEnterprise') {
                cards = {
                    right: false,
                    vip: false,
                    enterpriseVip: true,
                    upEnterpriseVip: true,
                    matting: false
                };
            }
            break;
        case 'draftNumber':
        case 'worksNumber':
        case 'videoDuration':
        case 'pptImport':
            if (levelTypeTag === 'isPoor') {
                cards = {
                    right: false,
                    vip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            } else if (levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo') {
                cards = {
                    right: false,
                    vip: false,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            }
            break;
        case 'AIMatting':
            if (levelTypeTag === 'isPoor') {
                cards = {
                    right: false,
                    vip: true,
                    shopVip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: true,
                    matting: true
                };
            } else if (levelTypeTag === 'isTmpSolo' || levelTypeTag === 'isSolo') {
                cards = {
                    right: false,
                    vip: false,
                    shopVip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: true,
                    matting: true
                };
            } else if (levelTypeTag === 'isShop') {
              cards = {
                  right: false,
                  vip: false,
                  shopVip: false,
                  enterpriseVip: true,
                  upEnterpriseVip: true,
                  matting: true
              };
            }else if (levelTypeTag === 'isTmpEnterprise' || levelTypeTag === 'isTmpSupremeEnterprise' || levelTypeTag === 'isGloryEnterprise' || levelTypeTag === 'isUpGloryEnterprise') {
                cards = {
                    right: false,
                    vip: false,
                    enterpriseVip: false,
                    upEnterpriseVip: true,
                    matting: true
                };
            }
            break;
        case 'selfDefineCover':
        case '480P':
            if (levelTypeTag === 'isPoor') {
                cards = {
                    right: false,
                    vip: true,
                    enterpriseVip: true,
                    upEnterpriseVip: false,
                    matting: false
                };
            }
            break;
    }
    return cards;
}

export function upgradeText ({funcType,vipInfo,enterpriseInfo,upEnterpriseInfo}) {
    let vipText = '';
    let shopText = '';
    let enterpriseText = '';
    let upEnterpriseText = '';
    // console.log('vipInfo=============>', vipInfo);
    switch (funcType) {
        case 'materialCapacity':
            let capacity = 0;
            if (vipInfo.size > 1024) {
                capacity = Math.round((vipInfo.size / 1024)) + 'G';
            } else {
                capacity = vipInfo.size + 'M';
            }
            vipText = `解锁${capacity}素材空间容量`;
            enterpriseText = '素材空间容量无上限，畅享全线来画产品权益';
            break;
        case 'AIDubbing':
            vipText = `解锁每个月${vipInfo.kdxfTimes}次AI配音`;
            shopText = '解锁1200次AI配音';
            enterpriseText = '解锁每个月1000次AI配音，畅享企业专属音色';
            upEnterpriseText = '解锁无限次AI配音，畅享企业专属音色';
            break;
        case 'enterpriseSpeaker':
            enterpriseText = '解锁每个月1000次AI配音，畅享企业专属音色';
            upEnterpriseText = '解锁无限次AI配音，畅享企业专属音色';
            break;
        case '720P':
            // vipText = `解锁每个月${vipInfo.videoTransformTime}次720P导出`;
            vipText = '解锁无限次720P导出，畅享全线来画产品权益';
            enterpriseText = '解锁无限次720P导出，畅享全线来画产品权益';
            break;
        case 'applyWatermark':
          vipText = `解锁每个月${vipInfo.nonWatermark}次无水印/自定义水印 `;
          shopText = '解锁共120次去水印/自定义水印';
          enterpriseText = '解锁无限次无水印/自定义水印，畅享全线来画产品权益 ';
          break;
        case 'removeWatermark':
            vipText = `解锁每个月${vipInfo.nonWatermark}次无水印 `;
            enterpriseText = '解锁无限次无水印，畅享全线来画产品权益 ';
            break;
        case 'selfDefineWatermark':
            vipText = ``;
            enterpriseText = '解锁自定义水印功能，畅享全线来画产品权益';
            break;
        case 'AIDrawing':
            vipText = `解锁AI绘图功能`;
            enterpriseText = '解锁AI绘图功能，畅享全线来画产品权益';
            break;
        case '1080P':
            vipText = ``;
            enterpriseText = '解锁无限次1080P导出，畅享全线来画产品权益';
            break;
        case 'draftNumber':
            // vipText = `最多可保留${vipInfo.draftNumber}个动画草稿`;
            vipText = '草稿、作品数量无上限，畅享全线来画产品权益';
            enterpriseText = '草稿、作品数量无上限，畅享全线来画产品权益';
            break;
        case 'worksNumber':
            // vipText = `最多可保留${vipInfo.videoNumber}个动画草稿`;
            vipText = '草稿、作品数量无上限，畅享全线来画产品权益';
            enterpriseText = '草稿作品数量无上限，畅享全线来画产品权益';
            break;
        case 'videoDuration':
            const text = countDuration(vipInfo);
            // vipText = `最长可制作时长${text}的视频`;
            vipText = '制作视频时长无上限';
            enterpriseText = '制作视频时长无上限，畅享全线来画产品权益';
            break;
        case 'pptImport':
            let vsize = vipInfo.pptSize;
            let esize = enterpriseInfo.pptSize;
            vipText = `支持导入${vsize}M的PPT`;
            enterpriseText = `支持导入${esize}M的PPT，畅享全线来画产品权益`;
            break;
        case 'AIMatting':
            vipText = `解锁一键抠图每天${vipInfo.cutoutTimes}张次数`;
            shopText = `解锁一键抠图每天${shopInfo.cutoutTimes}张次数`;
            enterpriseText = `解锁抠图每年${enterpriseInfo.cutoutTimes}张，畅享全线来画产品权益`;
            upEnterpriseText = '解锁无限次AI抠图';
            break;
        case 'selfDefineCover':
            vipText = `支持自定义视频封面`;
            enterpriseText = '支持自定义视频封面，畅享全线来画产品权益';
            break;
        case '480P':
            vipText = `解锁无限480P导出，每个月${vipInfo.videoTransformTime}次720P导出`;
            enterpriseText = '解锁高画质导出无限次，畅享全线来画产品权益';
            break;
    }
    return {
        vipText,
        shopText,
        enterpriseText,
        upEnterpriseText
    }
}

function countDuration (vipLevelInfo) {
    // vipLevelInfo.videoDuration = 3600;
    let hour = Math.floor(vipLevelInfo.videoDuration / 3600);
    let minute = Math.floor((vipLevelInfo.videoDuration - hour * 3600) / 60);
    let seconds = vipLevelInfo.videoDuration - hour * 3600 - minute * 60;
    let text1 = hour ? hour + '小时': '';
    let text2 = minute ? (seconds ? minute + '分': minute + '分钟'): '';
    let text3 = seconds ? seconds + '秒': '';
    return text1 + text2 + text3;
}



// WEBPACK FOOTER //
// ./src/plugins/memberGuide/types.js